import { companySplashType } from '@services/data-types/company';
import { splashInitial } from '@services/initialvalue/company';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CompanyState {
    splash: companySplashType,
    updateSplash: (auth: companySplashType) => void


}

export const useCompanyStore = create<CompanyState>()(
    persist(
        (set, get) => ({
            splash: splashInitial,
            updateSplash: (company: companySplashType) => {
                console.log(company)
                set(prev => ({ ...prev, splash: company }))
            },
        }),
        {
            name: 'company',
            serialize: (state) => btoa(JSON.stringify(state)),
            deserialize: (str) => JSON.parse(atob(str)),
        }
    )
);